$(function() {

//==========================================================================
// MODULE STATE
//==========================================================================

var docEl;
var $window;
var $document;
var $components;

//==========================================================================
// ENTRY POINT
//==========================================================================

init();

//==========================================================================
// INIT
//==========================================================================

//-----

function init() {
    // init module state
    initModuleState();

    // if there are no related components on the page, return
    if (!$components.length) return;

    // for each component, do stuff
    __($components).each(manageComponent);
}

//-----

//==========================================================================
// FUNCTIONS
//==========================================================================

//-----

function initModuleState() {
    $window       = $(window);
    $document     = $(document);
    $components   = $('section.contenido-basico-v2');
    docEl         = document.documentElement;
}

//-----

function manageComponent(component) {
    var $component = $(component);
    $component.find('[data-background]').each(function(i, el) {
        var $el = $(el);
        $el.css('background-image', 'url(' + $el.data('background') + ')');
    });
}

//-----

});
